import React, {PureComponent} from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {Helmet} from "react-helmet";
import { Link, withRouter } from "react-router-dom";
import './ProductDetail.css';
import CircularProgressbar from 'react-circular-progressbar';
// import {FaCheck} from 'react-icons/fa';
import { RESPONSE_STATUS } from '../../utils/constants';
import * as util from '../../utils/util';
import { Radar } from 'react-chartjs-2';
import Rating from 'react-rating';
import ReactSVG from 'react-svg';
import Modal from 'react-responsive-modal';
import { Elements } from 'react-stripe-elements';
import ReactGA from 'react-ga';
import {Loader } from 'semantic-ui-react'
import LoadingBlock from '../../components/common/LoadingBlock';
import Slider from 'react-slick'
// import {TiHeartOutline, TiHeartFullOutline} from 'react-icons/ti';
import RecommendationsCheckout from '../recommendations/RecommendationsCheckout';
import ReviewProduct from  "../../components/review/reviewProduct";
import ShowThankYous from '../showThankYous/showThankYou'
import Product from '../../components/product/Product';


import { addOrDeleteCartGoodsData,deleteAllCartGoodsData } from '../../actions/cartAction';
import Api from '../../utils/api';
import { Progress,Radio } from 'semantic-ui-react'
import Responsive from 'react-responsive';
import HttpUtils from '../../utils/http';
import {isJSON} from '../../utils/util';
import * as zenscroll from 'zenscroll';
import { relative } from 'path';
const indexMapProductsLabeled = {"cleanser":1,"exfoliator":2,"serum":3,"toner":4,"moisturizer":5,"spf":6,"eye cream":7,"mask":8,"make-up remover":11,"treatment":12,"supplement":15};

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={"slick-arrow custom-arrow-left"} style={onClick ? null : {display:'none'}}
        onClick={onClick}
      />
    );
}

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={"slick-arrow custom-arrow-right"}  style={onClick ? null : {display:'none'}}
        onClick={onClick}
      />
    );
}

class ProductDetail extends PureComponent {
    constructor(props){
        super(props);

        this.closeReviewModal = this.closeReviewModal.bind(this);
        this.fun_openProductReview = this.fun_openProductReview.bind(this);

        this.authToken = "";
        if(localStorage.getItem("auth_token")){
            this.authToken = Api.auth_tokenManager();
        }

        this.userId = localStorage.getItem("user_id");

        this.state = {
            addedToCart: false,
            cartGoodsIdList:this.props.cartGoodsList,
            showDescription: false,
            product: {},
            isFirstTime: false,
            loading: true,
            loadingPurchase: false,
            recommendedProducts: [],
            productCart: [],
            productArr: [],
            productViews: [],
            userPaidGateFee: false,
            productTypes: [],
            price: "0.00",
            optInTimerStarted: false,
            optInStartTime: null,
            showThankYou: false,
            optInTimerFinished: false,
            eligibleForDiscount: false,
            eligibleGatePaid: false,
            eligibleCardOnStripe: false,
            eligiblePreviouslyPurchased: false,
            openCancelModal: false,
            defaultPurchaseStatus: '',
            openPaymentConfirmModal: false,
            heartFilled: false,
            orderEnd:false, // Whether to complete the purchase
            orderId: '',
            orderSubtotal: 0,
            searchSameTypeValue: ['Cleanser','exfoliator','toner','face serum','moisturizer'],
            IsSearchSKinType: false,
            showProductDescription:true,
            showproductBrand:false,
            showIngredients: false,
            reviewsData:[],
            openReviewModal:false,
            productReviewInfo:[], // 评论这件商品，先获取商品评论所需要的数据
            ProductScore: 0,
            isLoader:false,
            allReviewsLoader:false,
            averageNumber:0,
            vettedProducts: [],
            productDescription:'',
            reviewsShowData:10,
            mceDefaultStyles:'<style id="mceDefaultStyles" type="text/css">   p { margin-top: 0;}html, body {     cursor: text;   }html {     font-size: 62.5%;   }body {     overflow-x: hidden;     font-family: -apple-system, BlinkMacSystemFont, San Francisco, Segoe UI, Roboto, Helvetica Neue, sans-serif;     font-size: 1.4em;     color: #212B36;   }   @media only screen and (max-device-width: 40em) {     body {       font-size: 1.6em;     }   }body {     overflow-x: hidden;     font-family: -apple-system, BlinkMacSystemFont, San Francisco, Segoe UI, Roboto, Helvetica Neue, sans-serif;     font-size: 1.4em;     color: #212B36;   }   @media only screen and (max-device-width: 40em) {     body {       font-size: 1.6em;     }   }h1, h2, h3, h4, h5, h6, p {     margin: 0 0 1em 0;     line-height: 1.4;   }table {     width: 100%;   }table, td, th {     border: 1px dashed #CCC;   }.mce-content-body div.mce-resizehandle {position: absolute;border: 1px solid black;box-sizing: box-sizing;background: #FFF;width: 7px;height: 7px;z-index: 10000}.mce-content-body .mce-resizehandle:hover {background: #000}.mce-content-body img[data-mce-selected],.mce-content-body hr[data-mce-selected] {outline: 1px solid black;resize: none}.mce-content-body .mce-clonedresizable {position: absolute;outline: 1px dashed black;opacity: .5;filter: alpha(opacity=50);z-index: 10000}.mce-content-body .mce-resize-helper {background: #555;background: rgba(0,0,0,0.75);border-radius: 3px;border: 1px;color: white;display: none;font-family: sans-serif;font-size: 12px;white-space: nowrap;line-height: 14px;margin: 5px 10px;padding: 5px;position: absolute;z-index: 10001} .mce-visual-caret {position: absolute;background-color: black;background-color: currentcolor;}.mce-visual-caret-hidden {display: none;}*[data-mce-caret] {position: absolute;left: -1000px;right: auto;top: 0;margin: 0;padding: 0;} .mce-content-body .mce-offscreen-selection {position: absolute;left: -9999999999px;max-width: 1000000px;}.mce-content-body *[contentEditable=false] {cursor: default;}.mce-content-body *[contentEditable=true] {cursor: text;} </style>',
            prodct_SliderSettings:{
                dots: false,
                infinite: false,
                speed: 250,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows:false,
                className: "ha-slider-recommendations not-ha-style",
               
                responsive: [
                  {
                    breakpoint: 900,
                    settings: {
                      slidesToShow: 4,
                      slidesToScroll: 1,
                    }
                  },
              
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                      prevArrow: <SamplePrevArrow />,
                      nextArrow: <SampleNextArrow />,
                      arrows:true,
                      infinite: false,
                    }
                  },
                  {
                    breakpoint: 766,
                    settings: {
                      slidesToShow: 1.2,
                      slidesToScroll: 1,
                      prevArrow: <SamplePrevArrow />,
                      nextArrow: <SampleNextArrow />,
                      arrows:true,
                      infinite: false,
                    }
                  },
                  {
                    breakpoint: 320,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      prevArrow: <SamplePrevArrow />,
                      nextArrow: <SampleNextArrow />,
                      arrows:true,
                      infinite: false,
                    }
                  }
                ],
              },
              goodsSizes:[],
        }

    }

    // componentDidUpdate(prevProps) {
    //     if (prevProps.product !== this.state.product) this.setState({ product: prevProps.product });
    // }
    
   
    componentDidMount() {
        this.mounted = true;
        //测试下 
		// localStorage.setItem('visited_recommendations', true);
		// if (localStorage.getItem("user_id")) {
            if (localStorage.getItem("gift_user")) localStorage.removeItem("gift_user");

            if(!localStorage.getItem("auth_token")){
                this.fun_getVettedProductsData();
            }
            

            const showRecommendationFlag = localStorage.getItem("visited_recommendations");
			if (showRecommendationFlag && localStorage.getItem("auth_token")) {
				localStorage.setItem("recohasnotseenreco", true);
				this.setState({ isFirstTime: true });
				fetch("/api/user-flags", {
				method: 'PATCH',
				headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'x-auth-token': Api.auth_tokenManager()
				},
				body: JSON.stringify({
						userId: this.userId,
						showRecommendation: true
				})
				}).then(response => {});
            }

            //Product Data
            // if (!this.userId) {
            //     this.props.history.push('/signin');
            //     return;
            // }
              
			//Fetch data
			const userId = this.userId;
			const fetchedCartWithProducts = localStorage.getItem("recommendations_cart_fetched_with_prod");
			const fetchedProductTypes = localStorage.getItem("recommendations_fetched_product_types");
			const fetchedRecommendations = localStorage.getItem("recommendations_fetched");
			const fetchedDpStatus = (localStorage.getItem("recodpstatus") && localStorage.getItem("recodpstart")) && localStorage.getItem("recodppurchase");

			const giftUser = localStorage.getItem("gift_user");
			const visitedRecommendations = localStorage.getItem(`${userId}:enable_recommendations`);
            
            const promiseGetProduct = new Promise((res, rej) => {
                if (!this.props.location.state || !this.props.location.state.product) {
                    this.fetchProduct();
                } else {
                    this.setState({
                        product: this.props.location.state.product,
                        heartFilled: this.props.location.state.product && this.props.location.state.product.wished ? true : false,
                    });
                }
                return res();
            });

			const promiseGetCart = new Promise((res, rej) => {
				if (!fetchedCartWithProducts) {
					this.getCart();
				} else {
					this.setState({ productCart: JSON.parse(fetchedCartWithProducts).map(product => {
                        if (product && product.id) return product.id;
                    }), productArr: JSON.parse(fetchedCartWithProducts) }, () => {
                        this.calculatePrice();
                        if (this.state.productCart.includes(this.state.product.id)) {
                            this.setState({ addedToCart: true });
                        }
					});
				}
				return res();
            });
            

            // 是否需要获取推荐产品 有点模糊在这里还需要吗
			// const promiseFetchReco = new Promise((res, rej) => {
			// 	if (!fetchedRecommendations) {
			// 		this.fetchRecommendedProducts(false, () => {
			// 			return res(this.state.recommendedProducts);	
			// 		});
			// 	} else {
			// 		this.setState({ recommendedProducts: JSON.parse(fetchedRecommendations), productTypes: JSON.parse(fetchedProductTypes) });
			// 		return res(JSON.parse(fetchedRecommendations));	
			// 	}
			// });

			let promiseChain = [promiseGetProduct,promiseGetCart];
			if (this.mounted) Promise.all(promiseChain)
			.then((data) => {
                // this.checkDefaultPurchaseStatus();
				return data;
			}).then((data) => {
                // this.checkIfPreviouslyPurchased();
				return data;
			}).then((data) => {
				
				this.setState({ loading: false });
			}).catch(err => {
				console.log(err);
				alert("There was a problem fetching data:" + err)
			});
        // }
        
        // else {
		// 	this.props.history.push('/signin');
		// 	return;
        // }

        this.fun_getProductReviews();
    }

    componentWillReceiveProps(nextProps) {
        if(!nextProps.cartGoodsList.map(product => product.id).includes(this.state.product.id)){
            this.setState({ addedToCart: false})
        }
    }
    
    componentWillUnmount() {
        this.mounted = false;
    }

    // 获取商品的 score
    fun_getProductScoreData(){
        var productId = this.state.product.id;
        var recommendationsProductData = localStorage.getItem("recommendations_fetched");
        if( isJSON(recommendationsProductData) ){
            var ProductDataJson = JSON.parse(recommendationsProductData);
            var ind =  ProductDataJson.findIndex(arrProduct => arrProduct.id == productId);
            if(ind != -1){
                this.setState({
                    ProductScore: ProductDataJson[ind].score
                });
            }
            
        }
    }

    // 获取商品的评论
    fun_getProductReviews(lastReview_value){
        var productId = window.location.pathname.replace("/recommendations/products/", "");          //required product-id
        var limit = 10;                             //required   limit
        var userId = localStorage.getItem('user_id');   //required  user-id

        var sameSkinType = this.state.IsSearchSKinType;   //              same-skin-type
        // var lastReviewId = lastReviewId_value ? lastReviewId_value : 0;  // data type long    last-review-id
        var lastReviewNumber = lastReview_value ? lastReview_value : 0;
        var url = '';
        
        // if(lastReviewId != 0){
        //     url = `/api/product-reviews?product-id=${productId}&limit=${limit}&same-skin-type=${sameSkinType}&last-review-id=${lastReviewId}`;
        // }else{
        //     url = `/api/product-reviews?product-id=${productId}&limit=${limit}&same-skin-type=${sameSkinType}`;
        // }


        url = `/api/product-reviews?product-id=${productId}&limit=${limit}&same-skin-type=${sameSkinType}&offset=${lastReviewNumber}`;

        if(userId){
            url += "&user-id="+userId;
        }

        HttpUtils.get(url,false).then(response =>{
            this.setState({
                allReviewsLoader: false
            })
            if(lastReviewNumber && lastReviewNumber > 0){
                var reviewsDataArray = this.state.reviewsData;
                var reviewData3=[...reviewsDataArray, ...response];
                this.setState({
                    reviewsData:reviewData3
                },()=>{
                    this.fun_getAverageRating();
                })
                if(response.length < 1){
                    alert('No more reviews');
                }
            }else{
                this.setState({
                    reviewsData:response
                },()=>{
                    this.fun_getAverageRating();
                })
            }
          
        }).catch(err =>{
            console.log(err);
            this.setState({
                allReviewsLoader: false
            })
        })
    }

    fun_getAverageRating(){
       var reviewsData = this.state.reviewsData;
       var ratingSum = 0;
       reviewsData.forEach(element => {
        ratingSum+=element['rating'];
       });
       try {
        var AverageRating = parseInt(ratingSum / reviewsData.length);
        this.setState({
            averageNumber: AverageRating
        })
       } catch (error) {
           
       }
    }


    // 评论这件商品
    fun_openProductReview(){
        this.setState({isLoader:true})
        var productId = window.location.pathname.replace("/recommendations/products/", "");
        HttpUtils.get("/api/product-info-for-review?product-id="+productId).then((response)=>{

            this.setState({
                productReviewInfo: [response],
                isLoader: false
            },()=>{
                if(!!response){
                    this.setState({openReviewModal: true})
                }else{
                    this.setState({openReviewModal: false})
                }
            })
        }).catch(error => {
            this.setState({
                isLoader: false
            },()=>{
                alert("Network error, please contact administrator")
            })
        })
    }

    // 前一个产品，与后一个产品。点击按钮方法事件
    fun_getProductDatailView(ActionType){
        var productId = this.state.product.id;
        var recommendationsProductData = localStorage.getItem("recommendations_fetched");

        if( isJSON(recommendationsProductData) ){
            var ProductDataJson = JSON.parse(recommendationsProductData);
            ProductDataJson.sort((a, b) => {
                return indexMapProductsLabeled[a.type.toLowerCase()] - indexMapProductsLabeled[b.type.toLowerCase()];
            });

            var ind =  ProductDataJson.findIndex(arrProduct => arrProduct.id == productId);
            var id = '';
            if(ind != -1){
                
                if(ActionType == "previousProduct"){
                    if( ind == 0 ){
                        id = ProductDataJson[ProductDataJson.length -1]
                    }else{
                        id = ProductDataJson[ind-1].id
                    }
                    
                }else if(ActionType ==  "nextProduct"){
                    if( ind == (ProductDataJson.length -1) ){
                        id = ProductDataJson[0].id
                    }else{
                        id = ProductDataJson[ind+1].id
                    }
                    
                }
                this.props.history.push({pathname:"/recommendations/products/"+id});
            }else{
                id = ProductDataJson[0].id
                this.props.history.push({pathname:"/recommendations/products/"+id});
            }
            
        }
    }

    // 顶部的产品类型标签，选择后，进去此类型下的第一件产品
    rendertypeLabelBut(){
        var recommendationsProductData = localStorage.getItem("recommendations_fetched");
        if(!isJSON(recommendationsProductData) ){ return false}
        // if( isJSON(recommendationsProductData) ){
            var recommendedProducts = JSON.parse(recommendationsProductData);
            var productTypeArrar = []
            recommendedProducts.forEach(element => {
                if(  (productTypeArrar.findIndex(Product => Product == element.type) == -1) || productTypeArrar.length < 1 ){
                    productTypeArrar.push(element.type)
                }
            });
            const reviewBlocks = productTypeArrar.map((label,index) => {
                return (
                    <div key={index} className={this.state.searchType == label ? 'search-type-item action-type-item' : 'search-type-item'} onClick={()=>{this.setSearchTypeValue(label)}}>{label}</div>
                )
            })
            return (
                reviewBlocks
            );
    }
    
    setSearchTypeValue(value){
      this.setState({
        searchType: value
      },()=>{
          this.fun_selectProductType_toProductView(value)
      })
    }

    // 相同类型下的一件产品
    fun_selectProductType_toProductView(productType){
        var recommendationsProductData = localStorage.getItem("recommendations_fetched");
        var recommendedProducts = JSON.parse(recommendationsProductData);
        recommendedProducts.sort((a, b) => {
            return indexMapProductsLabeled[a.type.toLowerCase()] - indexMapProductsLabeled[b.type.toLowerCase()];
        });
        recommendedProducts.forEach(element => {
            if(element.type == productType){
                this.props.history.push({pathname:"/recommendations/products/"+element.id});
                return false;
            }
        })
    }

    fun_readAlReviewList(){
        var reviewsData = this.state.reviewsData;
     
        if(reviewsData.length > 0){
            this.setState({
                allReviewsLoader: true
            })
            this.fun_getProductReviews(reviewsData.length);
        }
    }

    changeRadio(){
        this.setState({
            IsSearchSKinType: !this.state.IsSearchSKinType
        },()=>{
            this.fun_getProductReviews()
        })
    }
    
    skinConcernMetricsDom(){
       var htmlDom = [];
       var skinConcernMetricsData = this.state.product.skinConcernMetrics;
        for (const key in skinConcernMetricsData) {
            if (skinConcernMetricsData.hasOwnProperty(key)) {
                const element = skinConcernMetricsData[key];
                htmlDom.push(
                    <div className="attribute-progress-item" key={key}>
                        <div className="attribute-progress-item-titel">{key}</div>
                        <div  className="attribute-progress-item-conten">
                            <div className="ui progress attribute-progress-ui">
                                <div className="bar attribute-progress-ui-bar" style={{width: (element*10)+'%'}}>
                                <div className="progress attribute-progress-ui-progress">{element}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        }
        return htmlDom;
    }

    // 关闭review poppup 商品评论弹窗
    closeReviewModal() {
		this.setState({
			openReviewModal: false
		},()=>{
            this.fun_getProductReviews();
        })
	}

    //Force Rerender to sync front end with cart after closing Checkout window
    forceRender = () => {
        // this.renderRecommendations(false, this.state.recommendedProducts);
        this.setState({ loading: true }, () => {
        		this.setState({ loading: false });
        });
    }

    fun_managerSkinTypeConten(skinType){
        const dryOily = !skinType ? null : (skinType.charAt(0) !== 'O' && skinType.charAt(0) !== 'C') && skinType.charAt(0) !== 'D' ? null : (skinType.charAt(0) === 'O'? "Oily" : (skinType.charAt(0) === 'C'? "Combination": "Dry"));
        const sensitiveResistant = !skinType ? null : skinType.charAt(1) !== 'S' && skinType.charAt(1) !== 'R' ? null : (skinType.charAt(1) === 'S'? "Sensitive" : "Non-sensitive");
        const pigmented = !skinType ? null : skinType.charAt(2) !== 'P' && skinType.charAt(2) !== 'N' ? null : (skinType.charAt(2) === 'P'? "Pigmented" : "Non-pigmented");
        const wrinkled = !skinType ? null : skinType.charAt(3) !== 'W' && skinType.charAt(3) !== 'T' ? null : (skinType.charAt(3) === 'W'? "Mature" : "Youthful");
        return `${dryOily}, ${sensitiveResistant}, ${pigmented}, ${wrinkled}`
    }


    calculatePrice = () => {
		let sum = 0;
		this.state.productArr.forEach(product => {
			if (product && product.price) {
				sum += parseFloat(product.price);
			}
		});
		this.setState({ price: sum.toFixed(2) });
	}

    //获取此产品信息
    fetchProduct = () => {
      const prodId = window.location.pathname.replace("/recommendations/products/", "");
      const userId = localStorage.getItem("user_id");
      let url = `/api/products/${prodId}`;
      if(userId) url+="?user-id="+userId;
      fetch(url , {
          method: 'GET',
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            //   'x-auth-token': Api.auth_tokenManager()
          }
      }).then((response) => response.json()).then(responseJson => {
          this.setState({ product: responseJson,heartFilled: responseJson && responseJson.wished ? true : false, },  () => {
            this.setState({
                searchType: responseJson.type,
                goodsSizes: responseJson.sizes ? responseJson.sizes : []
            })
            this.getCart();
            this.fun_getProductScoreData();
            this.fun_faceBookTracking(responseJson.id,responseJson.price);

          });
      }).catch(function(err) {
          console.log(err);
      });
    }

    fun_faceBookTracking(id,value){
        window.fbq('track', 'ViewContent',{
            value: value,
            currency: 'USD',
            content_type: 'product', // required property
            content_ids: id // required property, if not using 'contents' property
            }
        );
    }

    fun_gotoProductList(){
        let anchor = document.getElementById("review-commuitv-item-zone");
        zenscroll.center(anchor);
    }

    // Why is it good for you, 产品优点
    generateRecReason() {
        let reason = this.state.product.recReason ? this.state.product.recReason : "";
        let reasonSplitReturn = "";
        if(reason != ""){
            let reasonSplit = reason.split(". ");
            reasonSplitReturn = reasonSplit.map((sentence) => {
                return (
                    <div className="right-reason-item">
                        <i className="right-reason-item-icon"></i>
                        <div className="right-reason-item-text">{sentence + (sentence.charAt(sentence.length - 1) !== "." ? "." : "")}</div>
                    </div>
                )
            });
        }
        return reasonSplitReturn;
    }

    handleAddToCart = () => {
        if(this.state.product.inventory <= 0){
            alert('Out of stock');
            return false
        }else{
            this.setState({ addedToCart: !this.state.addedToCart }, () => {
                this.saveCartForLater(this.state.product);
            });
        }
    }

    closeModal() {
        this.setState({
            openModal: false,
            product: {},
            showIngredients: false,
            showProductDescription: true
        });
    }

    showIngredients() {
        this.setState({
            showIngredients: true,
            showProductDescription: false,
            showproductBrand:false,
        });
    }

    showDescription() {
        this.setState({
            showProductDescription: true,
            showIngredients: false,
            showproductBrand:false,
        });
    }

    showBrandOption(){
        this.setState({
            showproductBrand:true,
            showProductDescription: false,
            showIngredients: false
        });
    }

    generateProductName() {
        let name = this.state.product ? this.state.product.name: "";
        let vendor = this.state.product ? this.state.product.vendor : " ";
        // if (name.indexOf(vendor) > -1) {
        //     return name.replace(vendor, '');
        // }
        return name;
    }

    generatePrice(){
        let price_parts = this.state.product.price ? this.state.product.price.split(".") : 0;
        if(price_parts[1] === "0"){
            price_parts[1] = "00";
        }

        return price_parts[0] + "." + price_parts[1];
    }

    generateIngredients() {
        if (!this.state.product.ingredients) return "Ingredients not available.";
        let div = document.createElement("div");
        div.classList.add("ingredients-blurb");
        div.innerHTML = this.state.product.ingredients;
        let text = div.textContent || div.innerText || "";
        text = text.replace(/\s\|/g, ',');
        text = text.replace(/\|/g, ', ');
        return (
            <div className="product-ingredients">
                {
                    !this.state.ingredientsExpanded && text.length > 174 ? text.substring(0,174) + '...' : text
                }
                <a href="#/" onClick={this.toggleIngredientsExpand.bind(this)} className="read-more">
                {
                    text.length > 174
                     ? (!this.state.ingredientsExpanded ? "Read More" : "Show Less")
                     : null
                }
                </a>
            </div>
        );

    }

    toggleIngredientsExpand() {
        this.setState({ ingredientsExpanded: !this.state.ingredientsExpanded });
    }

    generateDescription() {
        // Strip HTML tags from description
        let div = document.createElement("div");
        div.classList.add("description-blurb");
        div.innerHTML = this.state.product.description;
        let text = '';
        text = div.textContent || div.innerText || "";
        text = text.replace(/<(?:.|\n)*?>/gm, '');
        this.setState({ productDescription: text });

        
        if(text != 'undefined' ){
            return (
                // <iframe src="/Blog" style={{width:'100%'}} allowtransparency="true" frameborder="0" scrolling="auto" srcdoc={ this.state.mceDefaultStyles + this.state.product.description}></iframe>
                <div className="product-description-text">
                    {
                        !this.state.descriptionExpanded && text.length > 174 ? text.substring(0,174) + '...' : text
                    }
                    <a href="#/" onClick={this.toggleDescriptionExpand.bind(this)} className="read-more">
                    {
                        text.length > 174
                         ? (!this.state.descriptionExpanded ? "Read More" : "Show Less")
                         : null
                    }
                    </a>
                </div>
            );
        }else{
            return ('')
        }
        
    }

    toggleDescriptionExpand() {
        this.setState({ descriptionExpanded: !this.state.descriptionExpanded });
    }

    

    fillRoundRect(ctx, l, t, w, h, r) {
        let pi = Math.PI;
        ctx.beginPath();
        ctx.arc(l + r, t + r, r, - pi, - 0.5 * pi, false);
        ctx.arc(l + w - r, t + r, r, - 0.5 * pi, 0, false);
        ctx.arc(l + w - r, t + h - r, r, 0, 0.5 * pi, false);
        ctx.arc(l + r, t + h - r, r, 0.5 * pi, pi, false);
        ctx.closePath();
        ctx.fill();
    }


    /**** CART FUNCTIONS */

     //Fetch Recommended Products
		 fetchRecommendedProducts = (additionalRecs, callback) => {
			const url = !additionalRecs ? "/api/surveys/result?user-id=" : "/api/surveys/extra-recommendation?user-id=";
	
			fetch(url + this.userId, {
				method: "GET",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					"x-auth-token": this.authToken
				}
			})
				.then(response => response.json())
				.then(responseJson => {
					this.setState({
						recommendedProducts: responseJson.recommendedProducts,
						productTypes:  responseJson.productTypes
					}, () => {
						const localData = JSON.stringify(this.state.recommendedProducts);
						localStorage.setItem("recommendations_fetched", localData);

                        if(!additionalRecs) localStorage.setItem("estheticianNote", responseJson['estheticianNote']);

						const localDataProductTypes = JSON.stringify(this.state.productTypes);
						// localStorage.setItem("recommendations_fetched_product_types", localDataProductTypes);
						callback();
					});
				})
				.catch(function(err) {
					console.log(err);
				});
		};

		//DEFAULT PURCHASE PROCESS RELATED
		checkIfPreviouslyPurchased = () => {
			// fetch('/api/user-orders/extended-with-products?user-id=' + this.userId, {
			// 		method: 'GET',
			// 		headers: {
			// 				'Accept': 'application/json',
			// 				'Content-Type': 'application/json',
			// 				'x-auth-token': this.authToken
			// 		}
			// }).then((response) => {
			// 		if (response.status >= 400 && response.status < 500) return;
			// 		else return response.json();
			// }).then(responseJson => {
	
			// 		if (responseJson && responseJson.length < 1) {
			// 			this.setState({ eligiblePreviouslyPurchased: true });
			// 			localStorage.setItem("recohasnotpurchased", true);
			// 			this.checkIfPaidGateFee();
			// 		} else {
			// 			return;
			// 			// localStorage.setItem("recohaspurchased", true)
			// 		}
					
					
					
			// }).catch(function(err) {
			// 		console.log(err)
			// });
	}
		
		checkIfPaidGateFee = () => {
			fetch('/api/user-flags/gate-fee-paid?user-id=' + this.userId, {
					method: 'GET',
					headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'x-auth-token': this.authToken
					}
			})
			.then((response) => response.json()).then(responseJson => {
					if (responseJson) {
						this.setState({ eligibleGatePaid: true });
						localStorage.setItem("recogatepaid", true);
						this.checkIfCardIsOnStripe();
					}
			})
			.catch(function(err) {
					alert("There was a problem getting the confirmation code. Please try again.");
			});
		}

		/*** DEFAULT PURCHASE API CALLS ***/
		checkIfCardIsOnStripe = () => {
			fetch('/api/stripe-customers/status?user-id=' + this.userId, {
					method: 'GET',
					headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'x-auth-token': this.authToken
					}
			})
			.then(response => response.json())
			.then(responseJson => {
					if (responseJson) {
						localStorage.setItem("recocardisonstripe", true);
                        this.setState({ eligibleCardOnStripe: true });
                        
                        // this.getAmountPaidGateFee();  这方法是获取客户第一次购买，是否有抵扣金额。新改动后，换成下面方法 getPlanTypeTierData
				        this.getPlanTypeTierData();
                        
						// if (!localStorage.getItem("recoeligiblefordiscount")) localStorage.setItem("recoeligiblefordiscount", true);
					} else {
						// localStorage.setItem("recocardisonstripe", false);
					}
			})
			.catch(err => {
					alert('There was a problem checking for eligibility: ' + err);
			});
		}

		checkIfEligibleForDiscount = () => {
			if ((this.state.defaultPurchaseStatus === "started" && this.state.eligibleCardOnStripe && this.state.eligibleGatePaid) && this.state.eligiblePreviouslyPurchased) {
				this.setState({ eligibleForDiscount: true });
				localStorage.setItem('recoeligiblefordiscount', true);
			} 
        }
        

        getPlanTypeTierData = () => {
            const userId = localStorage.getItem("user_id");
                fetch('/api/user-profiles/tier?user-id=' + userId, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-auth-token': Api.auth_tokenManager()
                }
                }).then((response) => response.json()).then(responseJson => {
                        try {
                                let amountPaidGateFee = 0;
                                if(responseJson == 1){
                                    amountPaidGateFee = 0;
                                }else if(responseJson == 2){
                                    amountPaidGateFee = 10;
                                }else if(responseJson == 3){
                                    amountPaidGateFee = 20;
                                }
                                this.setState({ amountPaidGateFee: amountPaidGateFee });
                                localStorage.setItem("planTier", responseJson);
                                localStorage.setItem("recogateamount", amountPaidGateFee);
                                if (amountPaidGateFee > 0) {
                                    this.checkIfEligibleForDiscount();
                                }
                        } catch (error) {
                                localStorage.removeItem("recogateamount");
                        }  
                }).catch(function(err) {
                        console.log("resp");
                });
        }

		getAmountPaidGateFee = () => {
			const url = '/api/gate-fees?user-id=' + this.userId;
			fetch(url, {
					method: 'GET',
					headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'x-auth-token': this.authToken
					}
			}).then((response) => {
					if (response.status >= 200 && response.status < 300) {
							let contentLength = parseInt(response.headers.get("content-length"), 10);
							if (contentLength === 0) {
									return null;
							} else {
									return response.json();
							}
					} else {
							this.setState({ amountPaidGateFee: 10 });
					}
			}).then(responseJson => {
					if ((responseJson === null || responseJson === undefined) || (responseJson && responseJson.length < 1)) {
							this.setState({ amountPaidGateFee: 10 });
							localStorage.setItem("recogateamount", 10);
					} else {
							this.setState({ amountPaidGateFee: responseJson.amount });
							localStorage.setItem("recogateamount", responseJson.amount);
					}

					if (responseJson.amount > 0) {
						this.checkIfEligibleForDiscount();
					}
			}).catch(function(err) {
					console.log("resp");
			});
		}

		handleOptOut = () => {
			const userId = localStorage.getItem("user_id");
			fetch('/api/default-purchases/opt-out?user-id=' + userId, {
					method: 'POST',
					headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'x-auth-token': Api.auth_tokenManager()
					}
			})
			.then(response => {
					if (response.status === RESPONSE_STATUS.OK || (response.status >= 200 && response.status < 300)) {
							this.setState({ defaultPurchaseStatus: "opt-out", openCancelModal: false }, () => {
									// this.props.defaultPurchaseStatus("opt-out");
									const url = 'https://hooks.zapier.com/hooks/catch/2569749/0yrokb/';
									/* const url = 'https://hooks.zapier.com/hooks/catch/2569749/oo5yzaj/'; */
									const date = new Date();
                                    const phone = "+1 " + this.formatPhoneNumber(localStorage.getItem('user_global_phone'));
                                    // const phone = localStorage.getItem('user_global_phone');
									fetch(url, {
											method: 'POST',
											body: JSON.stringify({
													"fields": {
															"First Name": localStorage.getItem('user_global_firstname'),
															"Last Name": localStorage.getItem('user_global_lastname'),
															"Phone": phone,
															"Timestamp": util.convertToStandardTime(date.getTime() / 1000),
															"Email": localStorage.getItem('user_global_email')
													}
											})
									})
									.catch(function(err) {
											alert("There was a problem opting out. Please try again.");
									});
							});
					} else {
							throw new Error("Server response error.")
					}
			})
			.catch(err => {
					alert('There was a problem opting out of your purchase: ' + err);
			});

		}

		formatPhoneNumber(phoneNumberString) {
	let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
	let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
	if (match) {
			return '(' + match[1] + ') ' + match[2] + '-' + match[3];
	}
	return null;
}
	

		 //DEFAULT PURCHASE PROCESS
		 //This component handles fetching the card and the function
		 //for saving the cart for later. This function is called
		 //by Product components.
		checkDefaultPurchaseStatus = () => {
			// return fetch('/api/default-purchases?user-id=' + this.userId, {
			// 		method: 'GET',
			// 		headers: {
			// 				'Accept': 'application/json',
			// 				'Content-Type': 'application/json',
			// 				'x-auth-token': this.authToken
			// 		}
			// })
			// .then(response => {
			// 		if (response.status >= 400 && response.status < 500) {
			// 				this.startTimerOptIn();
			// 				this.setState({ defaultPurchaseStatus: "not-started" });
			// 				localStorage.setItem("recodpstatus", "not-started");
			// 				throw new Error("pass");
			// 		} else {
			// 				return response.json();
			// 		}
			// })
			// .then(responseJson => {
			// 	this.setState({ defaultPurchaseStatus: responseJson.status });
			// 	// if (responseJson.status && ((responseJson.status === "complete") || (responseJson.status === "opt-out"))) {
			// 	// 	localStorage.setItem("recodpstatus", responseJson.status);
			// 	// } else {
			// 	// 	localStorage.setItem("recodpstatus", "started");
			// 	// }
			// 	// localStorage.setItem("recodpstart", responseJson.createdDate);
			// 	this.setState({ defaultPurchaseStartTime: responseJson.createdDate });
			// 	// localStorage.setItem("recodppurchase", responseJson.status === "opt-out" ? responseJson.lastModifiedDate : null);
			// 	this.setState({ defaultPurchaseEndTime: responseJson.status === "opt-out" || responseJson.status === "complete" ? responseJson.lastModifiedDate : null });
			// })
			// .catch(err => {
			// 		return;
			// 		// else alert("There was a problem checking the user's default purchase status: " + err);
			// });
        }
        
		startTimerOptIn = () => {
			fetch('/api/default-purchases/start?user-id=' + this.userId, {
					method: 'POST',
					headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'x-auth-token': this.authToken
					}
			})
			.then((response) => {
					if (response.status >= 200 || response.status < 300) {
							fetch('/api/default-purchases?user-id=' + this.userId, {
									method: 'GET',
									headers: {
											'Accept': 'application/json',
											'Content-Type': 'application/json',
											'x-auth-token': this.authToken
									}
							})
							.then(response => response.json())
							.then(responseJson => {
								localStorage.setItem("recodpstatus", "started");
								const url = 'https://hooks.zapier.com/hooks/catch/2569749/0z8ws2/';
								fetch(url, {
										method: 'POST',
										body: JSON.stringify({
												"First Name": localStorage.getItem("user_global_firstname"),
												"Last Name": localStorage.getItem("user_global_lastname"),
                                                "Phone": this.formatPhoneNumber(localStorage.getItem("user_global_phone")),
                                                // "Phone": localStorage.getItem("user_global_phone"),
												"Email": localStorage.getItem("user_global_email")
										})
								})
								.then(this.setState({ runTutorial: true, defaultPurchaseStatus: "started", defaultPurchaseStartTime: responseJson.createdDate }))
								.catch(function(err) {
										alert("There was a sending your status. Please try again.");
								});
							})
							.catch(err => {
									alert('There was a problem starting the  timer: ' + err);
							});
					}
			})
			.catch(err => {
					alert('There was a problem starting the default purchase process: ' + err);
			});

	}


    getCart = () => {
        var cartGoods = localStorage.getItem("recommendations_cart_fetched_with_prod");
        var cartGoodsJosn = [];
        if(util.isJSON(cartGoods)){
            cartGoodsJosn = JSON.parse(cartGoods);
        }
        this.setState({
            productCart: cartGoodsJosn.map(product => product.id)
        }, () => {
            this.syncProductArr();
            if (this.state.productCart.includes(this.state.product.id)) {
                this.setState({ addedToCart: true });
            }
        });
	}

	saveCartForLater = (product) => {
		const userId = this.userId;
        let productArr = this.state.productArr;
     
        if (!productArr){
            alert('Error in obtaining product information');
            return false;
        }
		const ind = productArr.findIndex(arrProduct => arrProduct.name === product.name);
		let productArrCopy = [];

		if (ind < 0) {
			productArrCopy = [...productArr, product];
		} else {
			productArrCopy = [...productArr.slice(0, ind), ...productArr.slice(ind + 1)];
		}
	
		
		let prodStr = productArrCopy.map(product => `${[product.id]}:1`).toString();
		if (productArrCopy.length > 0) {

            this.props.addOrDeleteCartGoodsData(product)

            this.setState({ productArr: productArrCopy }, () => {
                localStorage.setItem("recommendations_cart_fetched_with_prod", JSON.stringify(productArrCopy));
                this.calculatePrice();
            });
		}else {
			this.clearCart();
			this.setState({ productArr: [] }, () => {
				// localStorage.setItem("recommendations_cart_fetched_with_prod", JSON.stringify(productArrCopy));
				this.calculatePrice();
			});
		}
	}

	syncProductArr = () => {

        var cartGoods = localStorage.getItem("recommendations_cart_fetched_with_prod");
        var cartGoodsJosn = [];
        if(util.isJSON(cartGoods)){
            cartGoodsJosn = JSON.parse(cartGoods);
        }    
		this.setState({ productArr: cartGoodsJosn }, () => {
			this.calculatePrice();
		});
	}

	clearCart = () => {
        this.props.deleteAllCartGoodsData()
        this.setState({ productCart: [] });
    }

	handleDeleteProduct = (product) => {
		let productArr = this.state.productArr;
		const ind = productArr.indexOf(product);
		let productArrCopy = [];
		if (ind < 0) {
			productArrCopy = [...productArr, product];
		} else {
			productArrCopy = [...productArr.slice(0, ind), ...productArr.slice(ind + 1)];
		}

        this.props.addOrDeleteCartGoodsData(product)
        
        
        var cartProducIdtArr = []
        cartProducIdtArr = productArrCopy.map(product => product.id)

		this.setState({ productArr: productArrCopy}, () => {
            this.calculatePrice();

            if (cartProducIdtArr.includes(this.state.product.id)) {
                this.setState({ addedToCart: true });
            }else {
                this.setState({ addedToCart: false });
            }

			if (this.state.productArr.length < 1) this.setState({ openPaymentConfirmModal: false });
		});
	}

	//END DEFAULT PURCHASE


    openPaymentConfirmModal = () => {
        const count = this.state.productArr.length;
        if (count <= 0) {
            alert("You must select at least one product.");
            return;
        }
        this.setState({ openPaymentConfirmModal: true });
    }

    closePaymentConfirmModal = () => {
        this.setState({ openPaymentConfirmModal: false, amountAvailableForDiscount: 0, discountCodes: [], promoCodeSaved: "" });
    }

    /**** END CART FUNCTIONS */

    toggleLoading = (loadingPurchase) => {
        this.setState({ loadingPurchase: loadingPurchase });
    }
    
    // 在购物车中，完成购买后。展示ThankYou,关闭购物车页面。清空 localStorage
	showThankYou = (orderIdValue,orderSubtotalValue,sourceOrderId,orderProductsDataValue, goodsNumber) => {
		this.setState({ showThankYou: false, openPaymentConfirmModal: true}, () => {
			for (let key in localStorage) {
				if (key.includes("reco") && !key.includes("enable_")) localStorage.removeItem(key);
            }
            localStorage.removeItem('cart-products-ids');
			this.props.history.push({pathname:"/showThankYou",state:{'orderId':orderIdValue,'orderSubtotal':orderSubtotalValue,'sourceOrderId':sourceOrderId,'orderProductsData':orderProductsDataValue,'orderGoodsNumber':goodsNumber }});
        });
        // this.setState({
        //     showThankYou:true,
		// 	orderEnd:true, 
		// 	orderId: orderId,
		// 	orderSubtotal: orderSubtotalValue,
		// })
	}

    handleHeartClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const userId = localStorage.getItem("user_id");
        const url = '/api/product-wishlists';
        const prodId = this.state.product.id;

        if (!this.state.heartFilled) {
            fetch(url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-auth-token': Api.auth_tokenManager()
                },
                body: JSON.stringify({
                    'userId': userId,
                    'productId': prodId
                })
            }).then(response => {
                if (response.status === RESPONSE_STATUS.OK) {
                    this.setState({heartFilled: true});
                    // if (process.env.REACT_APP_ENV === 'prod') {
                    //     ReactGA.event({
                    //         category: 'Heart Clicked',
                    //         action: "Click",
                    //         label: this.state.product.name,
                    //         value: 1
                    //     });
                    // }
                } else {
                    alert("There was a problem to saving the product to your wishlist. Please try again.");
                }
            });

        } else {
            fetch(url, {
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'x-auth-token': Api.auth_tokenManager()
                },
                body: JSON.stringify({
                    'userId': userId,
                    'productId': prodId
                })
            }).then(response => {
                if (response.status === RESPONSE_STATUS.OK) {
                    this.setState({heartFilled: false});
                    if (process.env.REACT_APP_ENV === 'prod') {
                        ReactGA.event({
                            category: 'Heart Unclicked',
                            action: "Click",
                            label: this.state.product.name,
                            value: 1
                        });
                    }
                } else {
                    alert("There was a problem removing the product from your wishlist. Please try again.");
                }
            });
        }
    }

    // 没登录时，获取More HelloAva Vetted Products ，商品数据
    fun_getVettedProductsData(){
        const prodId = window.location.pathname.replace("/recommendations/products/", "");
        HttpUtils.get("/api/vetted-products?excluded-product-id="+ prodId,false).then((response)=>{
            this.setState({
                vettedProducts: response
            });
        })
    }


    render() {
        const product = this.state.product;
        const AddToCartButton = styled.div`
      button {
        background: #fff;
        border: 2px solid #272d67;
        border-radius: 28px;
        width: 160px;
        font-size: 20.8px;
        font-family: Montserrat, sans-serif;
        color: #272d67;
        letter-spacing: 0.03px;
        font-weight: 600;
        padding: 0.5em 0;
        margin-left:28px;
      }

      button.added {
        color: #fff;
        background: #272d67;
      }
    `;
    const brandTxtLg = {
        fontFamily: 'Montserrat, Helvetica, Arial, sans-serif',
        fontSize: '32px',
        fontWeight: '700',
        lineHeight: '1.25',
        letterSpacing: '0.3px',
        color: '#272d67',
    };

    const txtLg = {
        fontFamily: 'Montserrat',
        fontSize: '21px',
        color: '#272d67',
        marginTop:'29px',
        fontWeight: '600',
        lineHeight: 'normal',
        letterSpacing: 'normal',
    };

    let DescriptionAndIngredients = styled.div`
    font-size: 18px;
    font-family: Montserrat, Helvetica, Arial, sans-serif;
    font-weight: normal;
    margin-bottom: 14px;
    display: flex;
    justify-content: space-around;
    width: 100%;

        .link {
            width: 100%;
            text-align: center;
            padding: 1% 3%;
            border-bottom: solid 1px #272d67;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;

            a {
                border-bottom: none;
                font-family: Montserrat;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: 0px;
                color: #272d67;
            }

            &:hover,  {
                font-weight: 600;

                a:hover {
                    font-weight: 600;
                }
            }

            &.active {
                font-weight: 600;
                color: #272d67;
                border: solid 1px #272d67;
                border-bottom: none;

                a {
                    color: #272d67;
                    // border-bottom: solid 3px transparent;
                }
            }
        }
        `;

        let LowInStock = styled.div`
        color: #d0021b;
        font-size: 16px;
        font-weight: 600;
        margin-top: 1em;
        font-family: Montserrat;
        `

        let PriceAndAmount = styled.div`
        display: flex;
        flex-direction: row;
        justify-content: flex-left;
        width: 100%;
        `;
   
        let ProductImageHolder = styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex-basis: 42%;
        margin-right: 2%;
        `;

        let ProductImage = styled.img`
        max-width: 300px;
        height: 280px;
        `;
        let ProductInfo = styled.div`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 31px;
        `;

        let ProductInfoAndDescription = styled.div`
        display: flex;
        flex-direction: column;
        flex-basis: 50%;
        `;

        let BottomSection = styled.div`
        font-size: 14px;
        line-height: 1.4;
        letter-spacing: 0px;
        color: #060000;
        text-align: justify;
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-direction: row;
        margin-top: 52px;

        .radar-chart {
            flex-basis: 42%;

            canvas {
                width: 100% !important;
                height: auto !important;
            }
        }

        @media screen and (max-width: 767px) {
            flex-direction: row;
            flex-wrap: wrap;
        }
        `;
        let canonical =  "https://helloava.co"+window.location.pathname; 
        let titleText = this.state.product.name+" | HelloAva";
        return (

          <div>
            <Helmet>
                <title>{titleText}</title>
                <meta http-equiv="content-type" content="text/html; charset=UTF-8"></meta>
                <link rel="canonical" href={canonical}/>
                <meta name="description" content={this.state.product.name+": HelloAva The Brains Behind Your Beauty"} />
                <meta name="title" content={this.state.product.name+": HelloAva The Brains Behind Your Beauty"} ></meta>
            </Helmet>

            <h1 style={{display:'none'}}>{titleText}</h1>
            <h2 style={{display:'none'}}>{titleText}</h2>

            <div name="loadingInfo" style={ (this.state.loading || this.state.loadingPurchase)? {display:"block"}: {display:"none"} }>
              <LoadingBlock purchase={ this.state.loadingPurchase } />
            </div>
            

            <div name="productDetailInfo" style={ (this.state.loading || this.state.loadingPurchase || this.state.showThankYou )  ? {display:"none",position:'relative'}: {display:"block",position:'relative'}  }>
              <div className="product-detail-page">

              {
                this.state.ProductScore != 0 ?
                <Responsive maxWidth={ 767 }>
                    <div className="product-score phone-product-score">
                        <CircularProgressbar
                            percentage={ this.state.ProductScore}
                            strokeWidth={8}
                            textForPercentage={null}
                            styles={{
                                path: { stroke: `rgba(255, 173, 148, ${this.state.ProductScore / 100})` },
                                svg: {maxWidth: `61px`}
                            }}
                            counterClockwise={true}
                        />
                        <div className="product-score-label">
                            <div className="number">{this.state.ProductScore}</div>
                            <div className="matching-score">matching score</div>
                        </div>
                    </div>
                </Responsive>:null
            }
               
                {
                    ! localStorage.getItem("auth_token") ? 
                    <div className="productDetail-type-phone unloggedin-title"><a href="https://shop.helloava.co/">All products</a>/ <a href="#" onClick={()=>{this.setSearchTypeValue(product.type)}}>{product.type}</a></div>
                    : 
                    <div>
                        <Responsive minWidth={ 767 }>
                            <div className="search-type-zone">
                                {this.rendertypeLabelBut()}
                            </div>
                        </Responsive>
                        <Responsive maxWidth={ 767 }>
                            <div className="productDetail-type-phone">{localStorage.getItem("user_firstname")}’s Plan  / {product.type}</div>
                        </Responsive>
                    </div>
                }
                
                

                <div className="product-detail-page__section product-detail-page__section__top-section">
                  <ProductImageHolder className="image-holder">
                    <ProductImage alt={product.name} src={ product.coverImageSource } title={product.name}/>
                  </ProductImageHolder>

                  <div className="product-detail-page__section-block product-detail-page__section-block__description-block">
                    <ProductInfoAndDescription>
                        

                      <ProductInfo>
                        <div className="product-info">

                          <div className="product-name" style={ txtLg }>{ this.generateProductName() }</div>


                            <Responsive minWidth={ 767 }>                            
                              <div className="product-top-Grade-seeReview">
                                {
                                    this.state.averageNumber > 0 ?
                                    <div className="product-top-Grade">
                                    <Rating readonly={true} emptySymbol={<ReactSVG path="/images/common/star.svg" wrapperClassName="svg-wrapper" style={{ width: '20px', height: '20px', marginRight:'7px'  }}/>}
                                      fullSymbol={<ReactSVG path="/images/common/star-selected.svg" wrapperClassName="svg-wrapper selected" style={{ width: '20px', height: '20px', marginRight:'7px' }}/>}
                                      initialRating={this.state.averageNumber} />
                                  </div>: null
                                }
                                {this.state.averageNumber > 0 ? <div className="product-top-seeReview" onClick={()=>{this.fun_gotoProductList()}}>see review</div>: 
                                    <div className="product-top-seeReview" onClick={()=>{this.fun_gotoProductList()}}>be the first to write a review </div>
                                }
                              </div>
                            </Responsive>

                            <Responsive maxWidth={ 767 }>                            
                              <div className="product-top-Grade-seeReview">
                                {
                                    this.state.averageNumber > 0 ?
                                    <div className="product-top-Grade">
                                    <Rating readonly={true} emptySymbol={<ReactSVG path="/images/common/star.svg" wrapperClassName="svg-wrapper" style={{ width: '13px', height: '13px', marginRight:'3px'  }}/>}
                                        fullSymbol={<ReactSVG path="/images/common/star-selected.svg" wrapperClassName="svg-wrapper selected" style={{ width: '13px', height: '13px', marginRight:'3px' }}/>}
                                        initialRating={this.state.averageNumber} />
                                    </div>:null
                                }

                                {
                                    this.state.averageNumber > 0 ?
                                    <div className="product-top-seeReview" onClick={()=>{this.fun_gotoProductList()}}>Read reviews</div>
                                    : <div className="product-top-seeReview" onClick={()=>{this.fun_gotoProductList()}}>be the first to write a review</div>
                                }
                                
                                


                              </div>
                            </Responsive>


                            <div className="product-label-zone">
                            {
                                Object.keys(this.state.product).length > 0 && this.state.product.claims ? this.state.product.claims.map((product, index) => {
                                    return (
                                        <div className="product-label-item">{product}</div>
                                    )
                                }) : null
                            }
                            </div>

                            <div className="product-sizes-select-contan" style={this.state.goodsSizes.length > 0 ? null : {display:'none'}  }>
                                <span className="paragraphSemiBold2 product-sizes-select-title navy">Size: </span>
                                <select className="product-sizes-select paragraphRegular3">
                                    {
                                        this.state.goodsSizes.map((productMap,index)=>{
                                            return (
                                                <option>{productMap}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                       

                            {/* <div className="yotpo bottomLine"
                                data-appkey="gRjSCGIzU9xdNC0V20Ddl9U8weptSG8dP65jQpYA"
                                data-domain="helloava.co"
                                data-product-id={this.state.product.id}
                                data-product-models={this.state.product.id}
                                data-name={this.state.product.name}
                                data-url="https://helloava.co"
                                data-image-url={this.state.product.coverImageSource}
                                data-description={this.state.product.description}
                                // data-bread-crumbs="{% for tag in product.tags %}{{ tag | escape }};{% endfor %}"
                                >
                            </div> */}
                        </div>

                        <div className="price-addButton-zone">
                          <PriceAndAmount>
                              <div className="price">${ this.state.product.price ? this.generatePrice().slice(0 ,-3) : ''  }</div>

                          </PriceAndAmount>

                          <AddToCartButton>
                            <button className={ this.state.addedToCart ? "product-detail-page__cart-button added card-button" : "product-detail-page__cart-button card-button" } onClick={ this.handleAddToCart } >
                              { this.state.addedToCart ? "Added" : "Add" }
                              <i className="cart-icon"></i>
                            </button>
                          </AddToCartButton>
                        </div>
                       


                        {/*<QuantityAndLastsFor>
                            <div className="quantity">Quantity: 1</div>
                            <div className="lasts-for">Usually lasts for 4 months</div>
                        </QuantityAndLastsFor>*/}
                        {
                            product.inventory <= 0 ?
                            <LowInStock>
                                <div className="low-in-stock">Out of stock</div>
                            </LowInStock>
                            : null
                        }
                      </ProductInfo>

                      <DescriptionAndIngredients>
                          <div className={this.state.showProductDescription ? "link active" : "link"}>
                              <a href="#/" onClick={this.showDescription.bind(this)} className="link-label">Details</a>
                          </div>
                          <div className={this.state.showIngredients ? "link active" : "link"}>
                              <a href="#/" onClick={this.showIngredients.bind(this)} className="link-label">Ingredients</a>
                          </div>
                          <div className={this.state.showproductBrand ? "link active" : "link"}>
                              <a href="#/" onClick={this.showBrandOption.bind(this)} className="link-label">The Brand</a>
                          </div>
                      </DescriptionAndIngredients>
                      <div className="product-description">
                          {
                              this.state.showProductDescription ? this.generateDescription() : null
                          }

                          {
                              this.state.showIngredients ? this.generateIngredients(): null
                          }

                          {
                              this.state.showproductBrand ? <div className="product-description">{this.state.product.brandDescription}</div> : null
                          }
                      </div>
                    </ProductInfoAndDescription>
                  </div>
                </div>

                <div className="productDetail-solid"></div>
                {
                    ! localStorage.getItem("auth_token") ?  
                    <div className="unlogged-img-transparen">
                        <img alt="transparen" src="/images/shop/transparen.png"></img>
                        <div className="shop-unlog-context">
                            <div className="shop-unlog-context-title">Is it good for me?</div>
                            <div className="shop-unlog-context-text">We need to get to know your skin first before we tell <br></br> you how well this product will work for you</div>
                            <div>
                                    <button onClick={()=>{ this.props.history.push("/onboarding") }} className="bat-style red-but un-log-takeskin-but">Take skin quiz to find out</button>
                            </div>
                        </div>
                    </div> 
                    :
                    <div style={this.state.product.type == 'Lip' ? {display:'none'} : {display:'block'} } className="product-detail-page__section product-detail-page__section__bottom-section">
                        <div className="product-detail-why-good-you-title">
                            Why is it good for you
                            <div className="product-detail-why-good-you-title-solid"></div>
                        </div>
                        <BottomSection className="score-and-good-zone">
                            <div className="score-and-good">
                            {
                                this.state.ProductScore != 0 ? 
                                    <Responsive minWidth={ 767 }>
                                    <div className="product-zone">
                                        <div className="product-score">
                                            <CircularProgressbar
                                            percentage={ this.state.ProductScore}
                                            strokeWidth={8}
                                            textForPercentage={null}
                                            backgroundPadding={2}
                                            styles={{
                                                path: { stroke: `rgba(255, 173, 148, ${this.state.ProductScore / 100})` },
                                                svg: {maxWidth: `150px`},
                                                strokeLinecap: 'butt',
                                            }}
                                            counterClockwise={true}
                                            />
                                            <div className="product-score-label">
                                                <div className="number">{this.state.ProductScore}</div>
                                                <div className="matching-score">Matching score</div>
                                            </div>
                                        </div>
                                    </div>
                                </Responsive>:null
                            }
                            <div className="attribute-progress-zone">{Object.keys(this.state.product).length > 0 ? this.skinConcernMetricsDom() : null }</div>    
                        </div>
                        <Responsive minWidth={ 767 }>
                        <div className="left-right-why-good-solid"></div>
                        </Responsive>
                        <div className="right-reason-zone"> {this.generateRecReason()} </div>
                    </BottomSection>
                </div>
            }
               
                {/* <div className="product-detail-page__section product-detail-page__section__review-section">
                  <div className="yotpo yotpo-main-widget"
                    // data-product-id={this.state.product.id}
                    data-product-id={this.props.match.params.id}
                    data-price={product.price}
                    data-currency="USD"
                    data-name={this.state.product.name}
                    data-url={window.location.href}
                    data-image-url={product.coverImageSource}
                    data-description={product.description}>
                  </div>
                </div> */}
              </div>
              {
                  localStorage.getItem("auth_token") ? null
                  :
                    <div className="vetted-Products-area">
                        <div className="productDetail-solid"></div>
                        <div className="more-products-area">
                            <div className="more-products-area-title">More HelloAva Vetted Products</div>
                            <div className="recommendation-section">
                                <div className="more-products-area-item-area products " style={{display:'block'}}>
                                    <Slider { ...this.state.prodct_SliderSettings } >
                                        {
                                            this.state.vettedProducts.map((productMap,index)=>{
                                                return <Product productCart={this.props.cartGoodsList}  product={productMap} index={ index } key={`product-${index}`} saveCartForLater={ this.props.addOrDeleteCartGoodsData }></Product>
                                            })
                                        }
                                    </Slider>
                                </div>
                            </div>
                        </div>
                        <div className="more-products-area-view-all">
                            <a href="https://shop.helloava.co/"  className="href-a">View all</a>
                        </div>
                    </div>
              }
              
              {
                  localStorage.getItem("auth_token") ?
                 <div>
                    <Responsive minWidth={ 767 }>              
                        <div className="productDetail-solid-previous-next">
                            <div className="product-previous-next-button" onClick={()=>{ this.fun_getProductDatailView('previousProduct') }}>
                                <i className="arrow-left"></i>
                                previous product
                            </div>

                            <div className="product-previous-next-button" onClick={()=>{ this.fun_getProductDatailView('nextProduct') }}>
                                next product
                                <i className="arrow-right"></i>
                            </div>
                        </div>
                    </Responsive>
                    <Responsive maxWidth={ 767 }>
                        <div className="productDetail-solid"></div>
                    </Responsive>
                 </div>
                :
                <div className="productDetail-solid"></div>
              }

              <div className="review-communitv-zone">
                <div className="product-detail-why-good-you-title" style={localStorage.getItem("auth_token") ? {} : {marginTop:'70px'} }>
                    Reviews from the community
                  <div className="product-detail-why-good-you-title-solid"></div>
                </div>

                <div className="review-communitv-contens">

                {
                    localStorage.getItem("auth_token") ?
                    <div className="review-communitv-contens-top-button-zone">
                      <div className="left-select-skin-type">
                      <Radio size="big" onClick={()=>{ this.changeRadio()}} className="select-type-radio product-radio mobile-productDetail-radio" toggle checked={this.state.IsSearchSKinType} label="Only the same skin type"></Radio>
                      </div>
                         
                        <div className="right-button-write">
                          <button className="write-size" onClick={this.fun_openProductReview}>
                            Write a review
                            <Loader active={this.state.isLoader}></Loader>
                          </button>
                      </div>
                  </div> : null
                }

                  <div className="review-commuitv-item-zone" id="review-commuitv-item-zone">
                    {
                     this.state.reviewsData.map((reviewItem, index) => {
                        return (
                            <div className="review-commuitv-item">
                                <div className="review-commuitv-item-top-area">
                                    <div className="review-commuitv-item-top-left-area">
                                        <div className="review-commuitv-item-title">
                                            <div className="review-userName">{reviewItem.reviewerFirstName}</div>
                                            {
                                            reviewItem.reviewerVerifiedBuyer ? <span className="review-verified paragraphSemiBold2">Verified buyer</span> : null
                                            }                            
                                        </div>
                                        <div className="review-time-sty">Review posted on {reviewItem.reviewSource} {reviewItem.reviewTime}</div>
                                    </div>

                                        <Responsive minWidth={ 766 }>
                                            <div className="review-commuitv-item-top-right-area">
                                                {
                                                    !reviewItem.reviewerSkinType && !reviewItem.reviewerSkinConcerns && !reviewItem.reviewerEthnicity && !reviewItem.reviewerAge ? null
                                                    :
                                                    <ul className="review-commuitv-item-ul" >
                                                        {
                                                            reviewItem.reviewerSkinType && reviewItem.reviewerSkinType !='Normal'  ? <li>Skin type:  <span>{this.fun_managerSkinTypeConten(reviewItem.reviewerSkinType)}</span> </li> :null
                                                        }
                                                        
                                                        {
                                                            reviewItem.reviewerSkinConcerns ? <li>Concerns: <span>{reviewItem.reviewerSkinConcerns}</span></li> :null
                                                        }
                        
                                                        {
                                                            reviewItem.reviewerEthnicity ? <li>Ethnicity: <span>{reviewItem.reviewerEthnicity}</span></li> : null
                                                        }

                                                        {
                                                            reviewItem.reviewerAge ? <li>Age: <span>{reviewItem.reviewerAge}</span></li> : null
                                                        }
                                                    </ul>
                                                }
                                            </div>
                                    </Responsive>  
                                </div>
                                

                                <div className="review-commuitv-item-bottom-contens">
                                    <div className="left-contens">
                                        <div className="review-commuitv-item-rating">
                                            <Responsive minWidth={ 767 }>                              
                                            <Rating readonly emptySymbol={<ReactSVG path="/images/common/star_orange.svg" wrapperClassName="svg-wrapper" style={{ width: '24px', height: '24px', marginRight:'7px'  }}/>}
                                                fullSymbol={<ReactSVG path="/images/common/star-selected_orange.svg" wrapperClassName="svg-wrapper selected" style={{ width: '24px', height: '24px', marginRight:'7px' }}/>}
                                                initialRating={ reviewItem.rating } />
                                            </Responsive>
                                            <Responsive maxWidth={ 767 }>                              
                                            <Rating readonly emptySymbol={<ReactSVG path="/images/common/star_orange.svg" wrapperClassName="svg-wrapper" style={{ width: '13px', height: '13px', marginRight:'3px'  }}/>}
                                                fullSymbol={<ReactSVG path="/images/common/star-selected_orange.svg" wrapperClassName="svg-wrapper selected" style={{ width: '13px', height: '13px', marginRight:'3px' }}/>}
                                                initialRating={ reviewItem.rating } />
                                            </Responsive>
                                        </div>


                                        <div className="review-commuitv-item-life-zone">
                                        {
                                            reviewItem.reviewTitle ? <div className="review-commuitv-item-feels-title">{reviewItem.reviewTitle}</div> : null
                                        }
                                            <div className="review-commuitv-item-life-conten">{reviewItem.comment}</div>
                                        </div>
                                        
                                        {
                                            reviewItem.productFeedbackOptions ? 
                                            <div className="review-commuitv-item-feels-zone">
                                                <div className="review-commuitv-item-feels-title">After using this {this.state.product.type}, my skin feels</div>
                                                <div className="review-commuitv-item-feels-conten">{reviewItem.productFeedbackOptions}</div>
                                            </div> : null
                                        }
                                    </div>

                                    {reviewItem.productFeedbackImageUrl ? 
                                        <div className="right-contens-img">
                                        <img alt="User profile" src={reviewItem.productFeedbackImageUrl}></img>
                                    </div> : null
                                    }
                                </div>
 
                                <Responsive maxWidth={ 766 }>
                                    {
                                        !reviewItem.reviewerSkinType && !reviewItem.reviewerSkinConcerns && !reviewItem.reviewerEthnicity && !reviewItem.reviewerAge ? null
                                        :
                                        <div className="review-commuitv-item-top-right-area mobile-r-c-i-style">
                                       
                                            <ul className="review-commuitv-item-ul" >
                                                {
                                                    reviewItem.reviewerSkinType && reviewItem.reviewerSkinType !='Normal'  ? <li>Skin type:  <span>{this.fun_managerSkinTypeConten(reviewItem.reviewerSkinType)}</span> </li> :null
                                                }
                                                
                                                {
                                                    reviewItem.reviewerSkinConcerns ? <li>Concerns: <span>{reviewItem.reviewerSkinConcerns}</span></li> :null
                                                }
                
                                                {
                                                    reviewItem.reviewerEthnicity ? <li>Ethnicity: <span>{reviewItem.reviewerEthnicity}</span></li> : null
                                                }

                                                {
                                                    reviewItem.reviewerAge ? <li>Age: <span>{reviewItem.reviewerAge}</span></li> : null
                                                }
                                            </ul>
                                        
                                    </div>
                                    }
                                </Responsive>
                            </div>
                        )
                     })
                    }
                  </div>
                      
                  <div className="bottom-buton-zone">
                      {
                          this.state.reviewsData.length >0 ? <button onClick={ ()=>{this.fun_readAlReviewList()}} className="button-styl-blue">Read all reviews <Loader active={this.state.allReviewsLoader}></Loader></button>
                          : <div className="no-review-open-review-popup" onClick={this.fun_openProductReview}>Be the first to <a>write a review!</a></div>
                      }
                  </div>

                </div>
              </div>
            </div>

            {/* (<div className="no-review-open-review-popup">Be the first to <a>write a review!</a></div> )  */}

            {/* <div className="no-review-open-review-popup">No reviews from your skin type group yet. Please try to turn off the “same skin type” toggle to <a>see all reviews.</a></div> */}

            <Modal open={ this.state.openPaymentConfirmModal } onClose={ this.closePaymentConfirmModal } /*little={ true }*/
                    classNames={{ overlay: 'ha-overlay payment-confirm-overlay', modal: 'ha-modal payment-confirm-modal', closeIcon: 'ha-modal-close' }} focusTrapped={ true }>
                    <Elements>
                            <RecommendationsCheckout 
                              productArr={ this.state.productArr }
                              price={ this.state.price }
                              // amountAvailableForDiscount={ localStorage.getItem("recogateamount") || this.state.amountAvailableForDiscount }
                              discountCodes={ this.state.discountCodes }
                              amountPaidGateFee={ localStorage.getItem("recogateamount") || this.state.amountPaidGateFee }
                              name={ localStorage.getItem("user_firstname") + " " + localStorage.getItem("user_lastname")}
                              eligibleForDiscount={ this.state.eligibleForDiscount }
                              handleDeleteProduct={ this.handleDeleteProduct }
                              forceRender={ this.forceRender }
                              toggleLoading={ this.toggleLoading }
                              showThankYou={ this.showThankYou }
                              clearCart={ this.clearCart }
                              hasNotPurchased={ this.state.eligiblePreviouslyPurchased }
                              saveCartForLater={ this.saveCartForLater }
                              productCart={ this.state.productCart }
                            />
                    </Elements>
                </Modal>

                <Modal open={ this.state.openReviewModal } onClose={()=>{ this.closeReviewModal() }} closeOnOverlayClick={false}
                    classNames={{ overlay: 'ha-overlay reviewProduct-overlay', modal: 'reviewProduct-confirm-modal', closeIcon: 'ha-modal-close' }}>
                    <ReviewProduct product={this.state.productReviewInfo} closeReviewModal={this.closeReviewModal}></ReviewProduct>
                </Modal>



            {
                this.state.showThankYou ?<div style={{marginTop: '-4em',marginBottom:'1em'}}><ShowThankYous ></ShowThankYous></div> :<div></div>
            }
            {
                    this.state.orderEnd ?
                    <div>
                        <img src={`https://www.shareasale.com/sale.cfm?tracking=${this.state.orderId}&amount=${this.state.orderSubtotal}&merchantID=77400&transtype=sale&sscidmode=6&sscid=${Api.fun_shareasaleGetCookie()}` } width="1" height="1"/>
                        <script defer async type="text/javascript" src="https://shareasale-analytics.com/j.js"></script>
                    </div>:<div></div>
                }
          </div>
        );
    }
}



function mapStateToProps(state) {
    const { helloava } = state;
    const { isAuthenticated } = helloava.auth;
    const { cartGoodsCount,cartGoodsList, cartPriceSum } = helloava.myCart;
    return { isAuthenticated,cartGoodsCount,cartGoodsList, cartPriceSum };
}

function mapDispatchToProps(dispatch) {
    return {
        addOrDeleteCartGoodsData: (product) => dispatch(addOrDeleteCartGoodsData(product)),
        deleteAllCartGoodsData: () => dispatch(deleteAllCartGoodsData())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail);



// WEBPACK FOOTER //
// ./src/views/productdetail/ProductDetail.js